import { createSelector } from 'reselect'
import interactiveVideoStatusTypes from 'helpers/enums/interactiveVideoCreation/videoStatusTypes'

const getInteractiveVideoCreationStatus = state => state.interactiveVideoCreation.status

export default createSelector(
	[ getInteractiveVideoCreationStatus ],
	status => (status !== interactiveVideoStatusTypes.UNLINKING)
)
